import React from "react";
import InitSession, { logout } from "../../session.initialize";
import {setupAxiosToken, setupXUserId} from "../../_helpers/http.helper";
import * as urlHelper from "../../_helpers/url.format.helper";
import AxiosClient from "../../_helpers/http.helper";
import config from '../../config';
import { ROLE_PERMISSIONS } from '../../constants/permissionsConstants';

const AuthContext = React.createContext();

export class AuthProvider extends React.Component {
    state = {
        isLoggedIn: false,
        userProfile: null
    };

    setUserProfile = (userProfile) => {
        this.setState({userProfile});
    };

    setLoginStatus = (status) => {
        this.setState({
            isLoggedIn: status
        });
    };

    componentDidMount() {
        InitSession(token => {
            setupAxiosToken(token);
            this.validateProfile(token, (profile => {
                this.setUserProfile(profile);
                this.setLoginStatus(true);
                this.renderNavBar(profile);
            }));
        });
    }

    validateProfile = (token, callback) => {
        const userProfileUrl = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.getUserProfile, {});
        AxiosClient.get(userProfileUrl, {headers: {'X-Authorization': token}}).then(profile => {
            setupXUserId(profile.data.id);
            const userGetUrl = urlHelper.formatUrl(
                config.identity.baseUrl,
                config.identity.routes.getUser, { userId: profile.data.id });
            AxiosClient.get(userGetUrl, {headers: {'X-Authorization': token}}).then(userInfo => {
                const defaultRole = userInfo.data.defaultRole ? userInfo.data.defaultRole.split(' ').join('_').toUpperCase() : "";
                const allowedRoles = ['PROJECT_SPECIALIST', 'LSA', 'SALES_REP'];
                profile.data.userRoles.forEach(role => {
                    if (allowedRoles.includes(role.replace(' ','_').toUpperCase())) {
                        profile.data.permissions.push(...ROLE_PERMISSIONS[role.replace(' ','_').toLowerCase()]);
                    }
                });
                let isContentAdmin = defaultRole === 'CONTENT_ADMIN';
                let redirectUrl = this.getLoginFailRedirectURL();

                if (isContentAdmin) {
                    redirectUrl = this.getContentAdminURL();
                    return window.location.replace(redirectUrl);
                }
                else if (!allowedRoles.includes(defaultRole)) {
                    window.location.replace(redirectUrl);
                    return null;
                }
                return callback(profile.data);
            });
        })
            .catch(function (error) {
                if (process.env.NODE_ENV !== "development") {
                    if (error.status === 401) {
                        window.location.replace(failureRedirectUrl);
                    }
                }
            });
    };

    getLoginFailRedirectURL = () => {
        return window.location.origin + "/";
    };

    getContentAdminURL = () => {
        return window.location.origin + "/contentadmin";
    };

    renderNavBar = profile => {
        var element = document.getElementById("header-container");
        var config = {
            session: "Session",
            user: { givenName: profile.username },
            onLogout: logout,
            mode: "Basic",
            consoleBaseUrl: window.location.origin + "/admintool",
            links: {
                home: "{consoleBaseUrl}/",
                myAccount: "",
                termsOfUse: "",
                privacyPolicy: ""
            }
        };

        document.dispatchEvent(
            new CustomEvent("o.DOMContentLoaded", {
                bubbles: true,
                detail: {
                    element: element,
                    config: config
                }
            })
        );
    };

    render() {
        const { children } = this.props;
        return (
            <AuthContext.Provider value={{...this.state}}>
                {children}
            </AuthContext.Provider>
        );
    }
}

export const AuthConsumer = AuthContext.Consumer;


// WEBPACK FOOTER //
// ./src/components/context/AuthContext.js